import React from 'react';
import { SectionLabel } from './ui/SectionLabel';
import { TestimonialCard } from './TestimonialCard';
import type { Testimonio } from '../data/content';
type TestimonialsProps = {
  label: string;
  title: string;
  testimonios: Testimonio[];
};
export function Testimonials({
  label,
  title,
  testimonios
}: TestimonialsProps) {
  return <section className="w-full bg-ink px-5 py-16 sm:px-8 sm:py-20" data-id="element-166" data-mp="3b01fr9oa1qri">
      <div className="mx-auto max-w-6xl" data-id="element-167" data-mp="36z95qe7kzhu6">
        <div className="text-center" data-id="element-168" data-mp="370ag0ggrw0au">
          <SectionLabel data-id="element-169" data-mp="32063t2mwdrqf">{label}</SectionLabel>
          <h2 className="mt-4 font-display text-3xl font-extrabold text-white sm:text-4xl" data-id="element-170" data-mp="31ybg5gk8rlin">
            {title}
          </h2>
        </div>
        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-171" data-mp="2s1qaqu4b88ea">
          {testimonios.map(testimonio => <li key={testimonio.name} data-id="element-172" data-mp="v9yfpaj1vt9q">
              <TestimonialCard testimonio={testimonio} data-id="element-173" data-mp="v8wvogk23wfv" />
            </li>)}
        </ul>
      </div>
    </section>;
}